import { defineStyleConfig } from '@/ui';

export const Link = defineStyleConfig({
  variants: {
    // https://github.com/chakra-ui/chakra-ui/issues/2870#issuecomment-758652112
    primary: ({ colorScheme = 'brand' }) => ({
      color: `${colorScheme}.500`,
    }),
    underline: ({ colorScheme = 'brand' }) => ({
      color: `${colorScheme}.500`,
      fontWeight: '500',
      textDecoration: 'underline',
    }),
  },
  defaultProps: {
    variant: 'primary',
  },
});
